import React, { useState } from "react";
import AntSwitch from "../AntSwitch";

const DMSwitch = ({tab, value, model, onUpdate, onChange}) => {
    const [selectedValue, setSelectedVaule] = useState(value)
    const handleChange = () => {
      setSelectedVaule(!selectedValue)
      onChange(!selectedValue);
      if(tab === 'models'){
        onUpdate(model,(!value))
      }
    }
    return <AntSwitch checked={selectedValue} onChange={handleChange} />
  }
  export default (DMSwitch);